module.exports = __webpack_public_path__ + "img/D-messenger-icon.cf7e5e25.svg";